export default __webpack_public_path__ + "images/nvent-brand-raychem.png?6c5d929a92bbfae10abc0143b29ec0b4";